/* eslint-disable new-cap */
(function ($) {
  'use strict';

  function initTable(_index, elem) {
    try {
      $(elem)
        .on('error.dt', function (_e, _settings, techNote, message) {
          console.error('An error has been reported by DataTables: ', message);
          console.log(`https://datatables.net/tn/${techNote}`);
        })
        .DataTable({
          paging: false,
          searching: false,
          info: false,
          ordering: false,
          autoWidth: false,
          columnDefs: [
            {
              render: function (data, _type, _row, meta) {
                var $header = $(
                  $(elem).DataTable().column(meta.col).header()
                ).html();
                return (
                  '<div class="responsive-table__header">' +
                  $header +
                  '</div><span>' +
                  data +
                  '</span>'
                );
              },
              targets: '_all',
            },
          ],
        });
    } catch (err) {
      console.error('Failed to load DataTable:', err.message);
    }
  }

  if (typeof $.fn.dataTable !== 'undefined') {
    $.fn.dataTable.ext.errMode = 'none';
  }
  var $standardTables = $('table:not(.responsive-table--no-datatable)');

  $standardTables.each(initTable);

  document.addEventListener('htmx:afterSwap', function (event) {
    var swapTarget = event.detail.elt;
    var $table = $(swapTarget).find('table');
    $table.each(initTable);
  });
})(jQuery);
